<template>
  <page-template>
    <template slot="page-content">
      <div class="lineup--template relative bg-beige" v-if="page.is_viewable">
        <div class="db dn-ns absolute is-black z-4000 bg-navy mobile-menu-lineup">
          <div
            class="relative flex flex-row items-center w-100 h3 bb-grey container-fluid"
          >
            <div class="flex w-100 flex-row justify-between">
              <a
                class="f3 mt2 ttu is-tablet-bold is-beige pointer"
                :href="lineup_nav_links_published[activeItemIndex].link"
                :title="lineup_nav_links_published[activeItemIndex].title"
                >{{ lineup_nav_links_published[activeItemIndex].title }}</a
              >
              <a
                class="w2 mt2 inline-flex pointer arrow-down-icon"
                :class="{ 'is-clicked': mobileMenuIconIsClicked }"
                @click="mobileMenuIconIsClicked = !mobileMenuIconIsClicked"
              >
                <simple-svg
                  class="green-arrow"
                  :filepath="'/uploads/plus.svg'"
                  :id="'arrow-down-icon-id'"
                >
                </simple-svg>
              </a>
            </div>
          </div>
          <transition name="slide-fade-rev">
            <div class="absolute bg-navy w-100 z-4000" v-show="mobileMenuIconIsClicked">
              <div
                class="relative flex flex-row items-center w-100 h3 container-fluid"
                v-for="(item, index) in lineup_nav_links_published"
                v-if="index != activeItemIndex"
                :key="item.title"
              >
                <a
                  class="f3 ttu mt2 is-tablet-bold is-beige pointer"
                  @click="
                    (activeItemIndex = index),
                      (mobileMenuIconIsClicked = !mobileMenuIconIsClicked)
                  "
                  :href="item.link"
                  :title="item.title"
                  >{{ item.title }}</a
                >
              </div>
            </div>
          </transition>
        </div>

        <!-- LINEUP MENU -->
        <div class="relative">
          <div class="relative z-content">
            <section class="relative mw12 flex flex-row z-1">
              <!-- MOBILE -->
              <div class="w-100 dn-ns" v-if="isWindowWidthMobile == true">
                <div class="container-fluid relative z-4 overflow-hidden">
                  <!-- Lineup nav -->
                </div>
              </div>
              <!-- DESKTOP -->
              <div
                class="dn relative flex-ns flex-grow-1"
                v-if="isWindowWidthMobile == false"
              >
                <div class="w-100 mw-24rem pv5 pl5 minh-450">
                  <div class="h-100">
                    <div class="info-bg sticky-nav">
                      <div class="pr5">
                        <a
                          :class="{ active: desktopActive == key }"
                          :href="item.link"
                          class="relative flex flex-row items-center tl w6 h3 bg-navy mb1 pl3 pointer select-hover-dt"
                          v-for="(item, key) in page.lineup_nav.links"
                          v-if="item.is_published"
                        >
                          <accordion :index="key" :desktopActive.sync="desktopActive">
                            <template slot="parent-nav-link">
                              <!-- LINEUP NAV LINK-->
                              <span
                                :class="{ active: desktopActive == key }"
                                class="f3 is-tablet-bold ttu is-beige txt-color"
                                :href="item.link"
                                >{{ item.title }}</span
                              >
                            </template>
                          </accordion>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 is-black lineup-margin">
                  <div class="ph6 mv5 z-4 relative">
                    <div class="z-4 relative">
                      <div class="db relative" v-if="isWindowWidthMobile == false">
                        <h2 v-if="(lineupActive === 0)" class="relative f2 mv3 is-lorano-bold is-black">2021 Lineup</h2>
              <h2 v-if="(lineupActive === 1)" class="relative f2 mv3 is-lorano-bold is-black">Soma Tent Lineup</h2>
              <h2 v-if="(lineupActive === 2)" class="relative f2 mv3 is-lorano-bold is-black">2021 The House by Heineken Lineup</h2>
                        <div
                          id="dostuff-embed-container"
                          ref="embedContainer"
                          class="w-100"
                        >
                          <div id="ds-fest"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div
            class="db dn-ns fixed top-0 bottom-0 w-100 bg-beige vh-100 z-3"
            :style="{ top: 10 * lineup_nav_links_published.length + 'px' }"
          ></div>
          <div class="db dn-ns relative container-fluid z-content">
            <div class="relative pv3 vh-50">
              <h2 v-if="(this.$route.path === '/lineup/' || this.$route.path === '/lineup' || this.$route.path === '/lineup//lineup/#/lineup_groupings/interactive-lineup/' || this.$route.path === '/lineup//lineup/#/lineup_groupings/interactive-lineup/' || this.$route.path === '/lineup/#/lineup_groupings/by-day-lineup')" class="f2 mv3 is-lorano-bold is-black">2021 Lineup</h2>
              <h2 v-if="(lineupActive === 1)" class="f2 mv3 is-lorano-bold is-black">Soma Tent Lineup</h2>
              <h2 v-if="(lineupActive === 2)" class="f2 mv3 is-lorano-bold is-black">2021 The House by Heineken Lineup</h2>
              <div id="dostuff-embed-container" ref="embedContainer" class="w-100">
                <div id="ds-fest"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lineup--template relative bg-beige pb5" v-else>
        <div class="relative container-fluid pv4">
          <h2 class="f2 mv3 ttu is-tablet-bold is-black">2021 info coming soon</h2>
        </div>
      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from "./page-template.vue";
import Accordion from "./accordion.vue";
export default {
  components: {
    PageTemplate,
    Accordion,
  },
  props: ["id", "pageMarkdownFileName"],
  metaInfo() {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        return titleChunk
          ? `${titleChunk} | ` + this.$site_seo_title_suffix
          : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: "description", name: "description", content: this.page.seo_description },
      ],
    };
  },
  data() {
    return {
      //bgOpaciy: 0,
      //bgScrollStart: this.$bgScrollStart,
      //scrollPos: 0,
      parallax: null,
      parallax2: true,
      lineupActive: 0,
      window: {
        width: 0,
        height: 0,
      },
      isWindowWidthMobile: null,
      desktopActive: 0,
      mobileActive: -1,
      mobileMenuIconIsClicked: false,
      activeItemIndex: 0,
    };
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName("lineup.markdown");
      return pageData[0];
    },
    lineup_nav_links_published: function () {
      var lineup_nav_links_published = this.page.lineup_nav.links.filter(function (item) {
        if (item.is_published === true) {
          //console.log('item: ', item);
          return item;
        }
      });
      return lineup_nav_links_published;
    },
  },
  methods: {
    scrollBg: function () {
      if (window.scrollY > this.bgScrollStart) {
        //console.log('scrollBg', window.scrollY, this.bgOpaciy);
        if (document.body.getBoundingClientRect().top > this.scrollPos) {
          if (window.scrollY > this.bgScrollStart) {
            this.bgOpaciy = window.scrollY * 0.001;
            //console.log('SCROLL UP: ', window.scrollY, this.bgOpaciy);
          } else {
            this.bgOpacity = 0;
          }
        } else {
          this.bgOpaciy = window.scrollY * 0.001;
          //console.log('SCROLL DOWN: ', window.scrollY, this.bgOpaciy);
        }
        // saves the new position for iteration.
        this.scrollPos = document.body.getBoundingClientRect().top;
      } else {
        this.bgOpaciy = 0;
      }
    },
    sizing: function () {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768) this.isWindowWidthMobile = true;
      else {
        this.isWindowWidthMobile = false;
        this.mobileActive = -1;
      }
      this.scrollBg();
      //if(this.swiper)
      //this.swiper.update();
    },
  },
  created() {
    this.window.width = window.innerWidth;
    this.window.height = window.innerHeight;
    if (this.window.width < 768) this.isWindowWidthMobile = true;
    else this.isWindowWidthMobile = false;

    if (this.$route.path == '/lineup/' || this.$route.path == '/lineup' || this.$route.path == '/lineup//lineup/#/lineup_groupings/interactive-lineup/' || this.$route.path == '/lineup//lineup/#/lineup_groupings/interactive-lineup/' || this.$route.path == '/lineup/#/lineup_groupings/by-day-lineup') {
        this.lineupActive = 0;
      }  else if (this.$route.path == '/lineup/#/lineup_groupings/soma-tent' || this.$route.path == '/lineup/#/lineup_groupings/soma-tent/'){
        this.lineupActive = 1;
      } else {
        this.lineupActive = 2;
      }

    window.addEventListener("load", this.sizing);
    window.addEventListener("resize", this.sizing);
    window.addEventListener("scroll", this.scrollBg);

    /* set lineup menu activeItem to the url it loaded on */
    let lineupLinksPublished = this.lineup_nav_links_published;
    if (this.$route.hash) {
      let activeItem = this.lineup_nav_links_published.filter(function (item) {
        if (item.link == "/lineup/" + window.location.hash) {
          //console.log('window.location.hash: ', window.location.hash);
          return item;
        }
      });
      var filterIndex = this.lineup_nav_links_published.findIndex(function (item) {
        return item.link == activeItem[0].link;
      });
      this.activeItemIndex = filterIndex;
      //console.log('dA + fI aI', this.desktopActive, filterIndex, this.activeItemIndex);
      this.desktopActive = filterIndex + 1;
    } else {
      this.activeItemIndex = 0;
      this.desktopActive = 0;
    }
  },
  beforeMount() {
    //
  },
  mounted() {
    if (this.$route.path === '/lineup/' || this.$route.path === '/lineup' || this.$route.path === '/lineup//lineup/#/lineup_groupings/interactive-lineup/' || this.$route.path === '/lineup//lineup/#/lineup_groupings/interactive-lineup/' || this.$route.path === '/lineup/#/lineup_groupings/by-day-lineup') {
        this.lineupActive = 0;
      }  else if (this.$route.path === '/lineup/#/lineup_groupings/soma-tent' || this.$route.path === '/lineup/#/lineup_groupings/soma-tent/'){
        this.lineupActive = 1;
      } else {
        this.lineupActive = 2;
      }
      console.log(this.lineupActive);
    this.$nextTick(() => {
      /* DOSTUFF EMBED INJECT */
      const liveLink = "https://osl-2020.dostff.co/embeds/lineup.js",
        previewToken = "ab186f6a47f16141e12d",
        previewLink = `https://osl-2020.dostff.co/embeds/lineup.js?preview_token=${previewToken}`;


      if (document.getElementById("ds-fest-lineup-js")) {
        //console.log('1.1 element exists');
      } else {
        //console.log('1.2 element does not exist!');
        var element = document.getElementById("dostuff-embed-container");
        let dostuffEmbedProd = document.createElement("script");
        dostuffEmbedProd.setAttribute("id", "dostuff-js");
        dostuffEmbedProd.setAttribute("type", "text/javascript");
        dostuffEmbedProd.setAttribute("ref", "myDiv");
        //dostuffEmbedProd.setAttribute('src', previewLink + previewToken);
        dostuffEmbedProd.setAttribute("src", liveLink);
        element.appendChild(dostuffEmbedProd);
        //console.log('1.4 lineup embed - created() ');
      }
    });
  },
  updated() {
      console.log(this.lineupActive);
  },
  beforeRouteUpdate(to, from, next) {
    if (to) {
      //console.log('Lineup - beforeRouteUpdate');
    } else {
      //console.log('else Lineup - beforeRouteUpdate');
    }
  },
  watch: {
    $route(to, from) {
      //
    },
  },
  beforeDestroy() {
    //
  },
  destroyed() {
    window.removeEventListener("load", this.sizing);
    window.removeEventListener("resize", this.sizing);
    //window.removeEventListener('scroll', this.scrollBg);
  },
};
</script>
